import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import localStorageFamilyInfo from '../../localStorageFamilyInfo';
import specificStyle from './specificStyle.module.scss';
import rStyles from '../DefaultcardStyles.module.scss';

const PageFour = ({ card, disableNext }) => {
  const [familyInfoData, setFamilyInfoData] = useState([]);
  const didMountRef = useRef(false);

  const getInitialData = () => {
    if (!didMountRef.current) {
      disableNext(true);
      const defaultValues = localStorageFamilyInfo.get(card);

      if (defaultValues) {
        setFamilyInfoData(defaultValues);
      }

      didMountRef.current = true;
    }
  };

  useEffect(() => getInitialData(), []);

  const isCardDataValid = () => familyInfoData.length > 0;

  const removeCardFromLocalStorage = () => {
    localStorageFamilyInfo.remove(card);
    disableNext(true);
  };

  const saveCardInLocalStorage = (data) => {
    localStorageFamilyInfo.save(card, data);
    disableNext(false);
  };

  useEffect(() => {
    if (!isCardDataValid()) removeCardFromLocalStorage();
    else saveCardInLocalStorage(familyInfoData);
  }, [familyInfoData]);

  return (

    <div className={rStyles.vacantest__card__content}>
      <>
        <div>
          <h3>Objetivos buscados por la Familia</h3>
          <p>
            Por favor, detalla los objetivos educacionales que se persiguen.
          </p>
        </div>
        <div
          className={rStyles.vacantest__section__container}
          style={{
            padding: '0',
            marginTop: '0',
          }}
        >
          <p className={specificStyle.text__area__label}>
            Descripción de los objetivos
          </p>
          <textarea
            type="text"
            value={familyInfoData}
            onChange={(e) => setFamilyInfoData(e.target.value)}
            className={specificStyle.text__area}
            placeholder="Descripción"
          />
        </div>
      </>
    </div>
  );
};

export default PageFour;

PageFour.propTypes = {
  card: PropTypes.number.isRequired,
  disableNext: PropTypes.func.isRequired,
};
